import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaAngular, FaNodeJs, FaDatabase, FaCode, FaCloud, FaChalkboardTeacher } from 'react-icons/fa';

function Skills() {
  const skills = [
    {
      icon: <FaAngular />,
      title: 'Angular',
      description: 'Expert-level Angular development for enterprise SPAs, including AngularJS through the latest versions.',
      color: '#dd0031',
    },
    {
      icon: <FaNodeJs />,
      title: 'Node.js',
      description: 'Backend development with Node.js, Express, and RESTful API design for scalable applications.',
      color: '#339933',
    },
    {
      icon: <FaDatabase />,
      title: 'Databases',
      description: 'SQL, MongoDB, ORMs — designing and optimizing data layers for both relational and NoSQL systems.',
      color: '#4479a1',
    },
    {
      icon: <FaCode />,
      title: 'Full Stack Dev',
      description: 'End-to-end application architecture from database design to front-end UI, ASP.NET, MVC, and modern SPA.',
      color: '#6f42c1',
    },
    {
      icon: <FaCloud />,
      title: 'DevOps & CI/CD',
      description: 'Git, Jenkins, custom deployment pipelines, PR management, and automated testing (unit & e2e).',
      color: '#0d6efd',
    },
    {
      icon: <FaChalkboardTeacher />,
      title: 'Technical Training',
      description: 'Worldwide classroom and remote training for developers on Angular and modern web frameworks.',
      color: '#e94560',
    },
  ];

  return (
    <section id="skills" className="skills-section section-padding">
      <Container>
        <div className="section-divider"></div>
        <h2 className="section-title">Skills & Expertise</h2>
        <p className="section-subtitle">Technologies and capabilities I bring to every project</p>

        <Row className="g-4">
          {skills.map((skill, index) => (
            <Col md={6} lg={4} key={index}>
              <div className="skill-card">
                <div className="skill-icon" style={{ background: `linear-gradient(135deg, ${skill.color}, ${skill.color}dd)` }}>
                  {skill.icon}
                </div>
                <h5>{skill.title}</h5>
                <p>{skill.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Skills;
